<template>
  <div id="quiz">
    <header class="header">
      <div class="header__left">
        <a href="https://www.werkgeluk.nl">
          <img class="logo logo-desktop" src="./../assets/img/logos/logo-werkgeluk.svg" alt="Werk & Geluk Logo">
          <img class="logo logo-mobile" src="./../assets/img/logos/logo-werkgeluk.svg" alt="Werk & Geluk Logo">
        </a>
        <div class="progress-indicator fade-in" v-if="step === 'quiz' && chapterCurrent != 6">
          <span class="progress-indicator__theme">Thema</span>
          <span class="progress-indicator__current">&nbsp;{{ chapterCurrent }}</span>
          <span class="progress-indicator__total">/{{ chapterTotal }}</span>
          <span class="progress-indicator__chapter">{{ questionchapter }}</span>
        </div>
      </div>
      <div class="header__right">
        <template v-if="step === 'quiz'">
          <div class="progress-indicator fade-in">
            <span class="progress-indicator__question">Vraag</span>
            <span class="progress-indicator__current"> {{ questionindex + 1 }} </span>
            <span class="progress-indicator__total">&nbsp;/&nbsp;&nbsp;{{ questionstotal }}</span>
          </div>
        </template>
      </div>
    </header>
    <main>
      <template v-if="step === 'quiz' && unemployed">
        <div class="left" :class="'bg-color-0' + chapterCurrent">
          <div class="left-contents">
            <div class="question" v-bind:class="{ fadein: stepFadeIn, fadeout: stepFadeOut }">Helaas kunnen wij jouw werkgeluk niet meten.
            </div>
          </div>
        </div>
        <div class="right">
          <div class="d-flex align-items-center h-100">
            <div class="answer align-center">
                <div class="tips p-8">
                  <h2>Helaas kunnen wij jouw werkgeluk niet meten.</h2>
                  <p>Wil je weten hoe je <a href="https://www.werkgeluk.nl/wat-voor-baan-past-bij-mij/?utm_medium=referral&utm_source=werkgeluk-test&utm_campaign=werk_en_geluk-werkgeluk-test-tell-prospecting" target="_blank" rel="noopener">een baan vindt die bij je past?</a> Hoe je <a href="https://www.werkgeluk.nl/hoe-ontdek-ik-mijn-passie/?utm_medium=referral&utm_source=werkgeluk-test&utm_campaign=werk_en_geluk-werkgeluk-test-tell-prospecting" target="_blank" rel="noopener">ontdekt wat jouw passie is</a>? Of <a href="https://www.werkgeluk.nl/sollicitatiegesprek-voorbereiden/?utm_medium=referral&utm_source=werkgeluk-test&utm_campaign=werk_en_geluk-werkgeluk-test-tell-prospecting" target="_blank" rel="noopener">hoe je perfect voorbereid het sollicitatiegesprek in gaat?</a></p>
                    <p>Meld je aan voor de werk&geluk nieuwsbrief en ontvang tweewekelijks tips, inspirerende verhalen en praktische informatie in je mailbox.</p>
                  <div class="d-flex flex-row justify-content-center">
                    <div><a
                    href="https://www.werkgeluk.nl/nieuwsbrief?utm_medium=referral&utm_source=werkgeluk-test&utm_campaign=werk_en_geluk-werkgeluk-test-tell-prospecting"
                    class="btn btn-next" target="_blank"
                    rel="noopener noreferrer">Stuur mij de nieuwsbrief</a></div><div class="ml-2 align-self-center">- Afmelden kan altijd, op ieder moment</div>
                  </div>
                  <div class="mt-6">
                  <p>Of lees eerst <a href="https://www.werkgeluk.nl/wat-voor-baan-past-bij-mij?utm_medium=referral&utm_source=werkgeluk-test&utm_campaign=werk_en_geluk-werkgeluk-test-tell-prospecting" target="_blank"
                                      rel="noopener noreferrer">enkele artikelen</a></p></div>
                </div>
              </div>
          </div>
        </div>
      </template>
      <template v-if="step === 'quiz' && !unemployed">
        <div v-for="(quiz, index) in quizez" v-if="index === questionindex">
          {{ changeChapter(quiz.chapterLabel) }}
          <div class="left" :class="'bg-color-0' + chapterCurrent">
            <div class="left-contents">
              <div class="question" v-bind:class="{ fadein: stepFadeIn, fadeout: stepFadeOut }">{{ quiz.question }}
              </div>
            </div>
          </div>
          <div class="right">
            <template v-if="quiz.type === 'emoticons'">
              <div class="d-flex align-items-center h-100">
                <div class="answer align-center">
                  <div class="label">Maak een keuze</div>
                  <div class="radio-elements emoticons">
                    <template v-for="(answer, index) in answers_emotions">
                      <input :class="answer.class" :id="quiz.id + index" type="radio" :name="answer.name"
                             v-model="answers[quiz.id]" :value="answer.value" data-aos="fade-up" data-aos-once="true"
                             data-aos-delay="200">
                      <label :for="quiz.id + index" v-on:mouseover="mouseOver(answer.name, answer.description)"
                             v-on:mouseleave="mouseLeave"
                             v-on:click="mouseClick(answer.name, answer.description)"><span class="answer-radio-hover-font">{{answer.description}}</span></label>
                    </template>
                  </div>
                  <div class="label-container">
                    <div class="label" v-show="hoverActive">
                      {{ opinions.totallyAgree }}
                      {{ opinions.agree }}
                      {{ opinions.neutral }}
                      {{ opinions.disagree }}
                      {{ opinions.totallyDisagree }}
                    </div>
                    <div class="label" v-show="!hideChecked && answers[quiz.id]">
                      {{ checked.totallyAgree }}
                      {{ checked.agree }}
                      {{ checked.neutral }}
                      {{ checked.disagree }}
                      {{ checked.totallyDisagree }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="quiz.type === 'list'">
              <div class="answer answer--padding align-left">
                <div class="label">{{ quiz.label }}</div>
                <template v-for="answer in quiz.answers">
                  <input :class="answer" :id="answer + quiz.id" type="radio" :name="quiz.id" v-model="data[quiz.id]"
                         :value="answer">
                  <label :for="answer + quiz.id"><span>{{answer}}</span></label>
                </template>
              </div>
            </template>

            <template v-if="quiz.type === 'textarea'">
              <div class="d-flex align-items-center h-100">
                <div class="answer answer--padding align-center">
                  <div class="label">Vul hieronder het antwoord in</div>
                  <textarea-autosize placeholder="Antwoord" :id="quiz.id" type="radio" :name="quiz.id"
                                     v-model="data[quiz.id]" rows="4"></textarea-autosize>
                </div>
              </div>
            </template>
            <template v-if="quiz.type === 'points'">
              <div class="d-flex align-items-center h-100">
                <div class="answer answer--padding align-center">
                  <div class="label">{{ quiz.label }}</div>
                  <div class="radio-elements">
                    <div class="row">
                      <input type="radio" id="hj-1" value="1" name="one" v-model="data[quiz.id]"/>
                      <label for="hj-1">1</label>
                      <input type="radio" id="hj-2" value="2" name="two" v-model="data[quiz.id]"/>
                      <label for="hj-2">2</label>
                      <input type="radio" id="hj-3" value="3" name="three" v-model="data[quiz.id]"/>
                      <label for="hj-3">3</label>
                      <input type="radio" id="hj-4" value="4" name="four" v-model="data[quiz.id]"/>
                      <label for="hj-4">4</label>
                      <input type="radio" id="hj-5" value="5" name="five" v-model="data[quiz.id]"/>
                      <label for="hj-5">5</label>
                    </div>
                    <div class="row">
                      <input type="radio" id="hj-6" value="6" name="six" v-model="data[quiz.id]"/>
                      <label for="hj-6">6</label>
                      <input type="radio" id="hj-7" value="7" name="seven" v-model="data[quiz.id]"/>
                      <label for="hj-7">7</label>
                      <input type="radio" id="hj-8" value="8" name="eight" v-model="data[quiz.id]"/>
                      <label for="hj-8">8</label>
                      <input type="radio" id="hj-9" value="9" name="nine" v-model="data[quiz.id]"/>
                      <label for="hj-9">9</label>
                      <input type="radio" id="hj-10" value="10" name="ten" v-model="data[quiz.id]"/>
                      <label for="hj-10">10</label>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="button-container-right" v-if="questionindex < quizez.length">
            <button class="previous-step btn btn-prev" v-if="questionindex > 0"
                    v-on:click="previousStep">Vorige
            </button>
            <button v-if="quiz.skip && !answers[quiz.id]" v-on:click="nextStep" class="skip btn btn-next">{{ quiz.skip }}</button>
            <template v-if="quiz.id === 'algemeen-5' && data[quiz.id] === 'Nee'">
              <button v-on:click.prevent="noJob" class="skip btn btn-next">Volgende</button>
            </template>
            <template v-if="quiz.id === 'algemeen-5' && data[quiz.id] === 'Ja' || quiz.id != 'algemeen-5'">
              <button :id="'question_' + (questionindex + 1)" class="btn btn-next"

                      v-if="(data[quiz.id] || answers[quiz.id]) && !nextStepActive || quiz.id == 'gender' || quiz.required == 'false'"
                      v-on:click="nextStep">Volgende
              </button>
            </template>
          </div>
        </div>
      </template>
      <template v-if="step === 'done'">
        <div class="user user-results">
          <div class="left results d-table" v-bind:class="classResults">
            <div class="left-contents d-table-cell align-middle position-relative">
              <GenerateHTML v-for="component in settingsLeftTop" :key="component.name" :component="component"/>
              <div class="response">
                <svg style="width: 100%; height: 100%; padding: 20%;" width="313px" height="353px" viewBox="0 0 313 353" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Group-49" transform="translate(-0.000100, 0.000000)">
                      <polygon id="Fill-1" fill="#3A6199" points="196.8895 342.0751 216.8305 351.4291 226.1845 331.4871 206.2435 322.1341"></polygon>
                      <polygon id="Fill-2" fill="#F7DF4D" points="71.8129 333.8509 84.1789 352.0779 102.4059 339.7119 90.0399 321.4849"></polygon>
                      <path d="M201.1145,93.8133 L43.5375,203.7053 L15.5035,12.1563 C14.2385,3.5143 23.3825,-2.8617 31.0545,1.3113 L201.1145,93.8133 Z" id="Fill-3" fill="#3A6199"></path>
                      <path d="M312.5,195.1788 C312.5,281.4728 242.545,351.4288 156.25,351.4288 C69.956,351.4288 0,281.4728 0,195.1788 C0,108.8848 69.956,38.9288 156.25,38.9288 C242.545,38.9288 312.5,108.8848 312.5,195.1788" id="Fill-5" fill="#F9C24D"></path>
                      <path d="M115.439,164.7887 L115.439,164.7887 C106.305,161.3717 96.243,161.3717 87.109,164.7887 L87.109,164.7887 C87.109,153.3507 93.451,144.0777 101.274,144.0777 C109.097,144.0777 115.439,153.3507 115.439,164.7887" id="Fill-8" fill="#000000"></path>
                      <path d="M170.875,232.3775 C170.875,240.4545 164.327,247.0025 156.25,247.0025 C148.173,247.0025 141.625,240.4545 141.625,232.3775 C141.625,224.3005 148.173,217.7525 156.25,217.7525 C164.327,217.7525 170.875,224.3005 170.875,232.3775" id="Fill-10" fill="#000000"></path>
                      <path d="M141.6253,232.3773 C141.6253,235.3133 142.5093,238.0353 143.9993,240.3263 L255.1363,240.3263 L255.1363,224.4283 L143.9993,224.4283 C142.5093,226.7193 141.6253,229.4413 141.6253,232.3773" id="Fill-12" fill="#679DD3"></path>
                      <path d="M20.0942,43.523 C31.7712,33.029 44.6542,23.855 58.5212,16.251 L42.0712,7.303 C33.4172,12.574 25.1702,18.44 17.3562,24.818 L20.0942,43.523 Z" id="Fill-14" fill="#D86183"></path>
                      <path d="M22.934,62.9258 L25.913,83.2798 C44.027,62.2108 67.136,45.5798 93.4,35.2228 L75.605,25.5438 C55.915,34.9218 38.117,47.6208 22.934,62.9258" id="Fill-16" fill="#D86183"></path>
                      <polygon id="Fill-18" fill="#D86183" points="176.1686 76.6118 156.2276 67.2578 165.5816 47.3168 185.5226 56.6708"></polygon>
                      <polygon id="Fill-20" fill="#F7DF4D" points="298.4175 133.9562 278.4765 124.6022 287.8305 104.6612 307.7715 114.0152"></polygon>
                      <polygon id="Fill-22" fill="#D86183" points="298.4175 336.7812 278.4765 327.4272 287.8305 307.4862 307.7715 316.8402"></polygon>
                      <polygon id="Fill-24" fill="#D86183" points="37.1994 319.7533 29.1844 340.2693 8.6684 332.2543 16.6834 311.7383"></polygon>
                      <polygon id="Fill-26" fill="#3A6199" points="31.622 261.3624 23.607 281.8784 3.091 273.8634 11.106 253.3474"></polygon>
                      <polygon id="Fill-28" fill="#3A6199" points="275.0774 58.1705 255.1364 48.8165 264.4904 28.8755 284.4314 38.2295"></polygon>
                      <polygon id="Fill-30" fill="#E6955B" points="113.5436 29.295 93.6026 19.941 102.9566 -5.68434189e-14 122.8976 9.354"></polygon>
                      <path d="M234.1102,209.5384 C235.7072,205.4494 240.3172,203.4294 244.4062,205.0274 C248.4952,206.6244 250.5152,211.2344 248.9182,215.3234 C247.3202,219.4124 242.7102,221.4324 238.6212,219.8344 C234.5322,218.2374 232.5132,213.6274 234.1102,209.5384" id="Fill-32" fill="#679DD3"></path>
                      <path d="M263.3504,196.7259 C251.7384,192.1889 238.6464,197.9259 234.1104,209.5379 L248.9174,215.3229 C250.2574,211.8939 254.1364,210.1939 257.5654,211.5339 C260.9944,212.8729 262.6944,216.7529 261.3544,220.1819 C260.3344,222.7949 257.8384,224.3789 255.1914,224.4039 L255.1914,224.4169 L233.7224,224.4169 C235.6574,230.7479 240.2684,236.1789 246.9224,238.7789 C258.5344,243.3149 271.6264,237.5789 276.1624,225.9669 C280.6994,214.3539 274.9634,201.2629 263.3504,196.7259" id="Fill-34" fill="#679DD3"></path>
                      <path d="M193.1708,240.3262 C187.8618,230.8942 179.2538,230.8942 173.9448,240.3262 L173.9448,240.3262 L193.1708,240.3262 Z" id="Fill-36" fill="#D86183"></path>
                      <path d="M252.7896,240.3262 C247.4806,231.8892 238.8726,231.8892 233.5636,240.3262 L233.5636,240.3262 L252.7896,240.3262 Z" id="Fill-38" fill="#D86183"></path>
                      <path d="M203.7542,224.4291 C209.0632,232.8671 217.6712,232.8671 222.9802,224.4291 L222.9812,224.4291 L203.7542,224.4291 Z" id="Fill-40" fill="#D86183"></path>
                      <path d="M144.1356,224.4292 C149.4446,233.8612 158.0526,233.8612 163.3616,224.4292 L163.3616,224.4292 L144.1356,224.4292 Z" id="Fill-42" fill="#D86183"></path>
                      <path d="M156.25,247.0025 C148.173,247.0025 141.625,240.4545 141.625,232.3775 C141.625,224.3005 148.173,217.7525 156.25,217.7525" id="Fill-44" fill="#000000"></path>
                      <path d="M225.7017,164.7887 L225.7017,164.7887 C216.5677,161.3717 206.5057,161.3717 197.3717,164.7887 L197.3717,164.7887 C197.3717,153.3507 203.7137,144.0777 211.5367,144.0777 C219.3597,144.0777 225.7017,153.3507 225.7017,164.7887" id="Fill-46" fill="#000000"></path>
                    </g>
                  </g>
                </svg>
              </div>
              <GenerateHTML v-for="component in settingsLeftBottom" :key="component.name" :component="component"/>
              <div class="results-comment text-left p-4 p-sm-6 mb-8 mb-md-0 mt-8">
                <div class="results-comment__title">
                  Deze score is gebaseerd op 4 factoren
                </div>
                <div class="results-comment__list">
                  <ul>
                    <li>je relatie met je collega’s</li>
                    <li>jouw competenties</li>
                    <li>jouw vrijheid in je werk</li>
                    <li>jouw maatschappelijke waarde</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="right d-flex flex-column justify-content-center">
            <div class="content content--padding" v-if="success === false">
              <GenerateHTML v-for="component in settingsRight" :key="component.name" :component="component"
                            :personal="personal" @checkform="checkFormValidate"/>
            </div>
            <div class="content content--padding" v-if="success === true">
              <GenerateHTML v-for="component in settingsRightSuccess" :key="component.name" :component="component"/>
            </div>
          </div>
        </div>
      </template>
    </main>
  </div>
</template>
<script>
  import database from './firebaseInit'
  import quiz_emoticons_answers from '../../data/answers.emotions.json'
  import projects from '../../data/projects.json'
  import getGrade from '../mixins/getGrade.js';
  import GenerateHTML from "./GenerateHTML.vue";

  // A reference to the users collection.
  var users = null;

  export default {
    name: 'app',
    mixins: [getGrade],
    components: {
      GenerateHTML
    },
    data() {
      return {
        answers: [],
        answers_emotions: quiz_emoticons_answers,
        chapter: null,
        chapterCurrent: null,
        chapterTotal: null,
        checked: [],
        collection: null,
        data: [],
        errorActive: false,
        grade: null,
        hideChecked: false,
        hoverActive: false,
        id: 'test',
        nextStepActive: false,
        opinions: [],
        paramStep: null,
        part: null,
        personal: [],
        personalFill: [],
        questionchapter: null,
        questionindex: 0,
        questionstotal: 0,
        quizez: [],
        settings: [],
        settingsLeftTop: [],
        settingsLeftBottom: [],
        settingsRight: [],
        settingsRightSuccess: [],
        step: 'quiz',
        stepFadeIn: true,
        stepFadeOut: false,
        success: false,
        newsletter: false,
        unemployed: false,
        uid: Date.now() + '-' + Math.random().toString().slice(2)
      }
    },
    computed: {
      classResults: function () {
        return {
          'results-color--red': this.grade < 5.5,
          'results-color--green': this.grade >= 5.5
        }
      },
      emotionsResults: function () {
        return {
          'emoticon--totally-agree': this.grade > 8,
          'emoticon--agree': this.grade >= 5.5 && this.grade <= 8,
          'emoticon--neutral': this.grade >= 5 && this.grade < 5.5,
          'emoticon--disagree': this.grade >= 3 && this.grade < 5,
          'emoticon--totally-disagree': this.grade >= 1 && this.grade < 3,
        }
      },
    },
    methods: {
      debug: function () {
        if (this.$route.query.step) {
          setTimeout(() => {
            this.questionindex = this.$route.query.step - 2;
            this.nextStep();
          }, 1000)
        }
        if (this.$route.query.grade) {
          setTimeout(() => {
            this.grade = this.$route.query.grade;
            this.quizDone();
          }, 1000)
        }
      },
      generateRandomInteger: function (min, max) {
        return Math.floor(min + Math.random() * (max + 1 - min))
      },
      changeChapter: function (chapter) {
        this.questionchapter = chapter;
      },
      nextStep: function (switchScreen) {
        this.switchScreenReset();

        if ((this.questionindex + 1) !== this.quizez.length) {
          this.chapterCurrent = this.quizez[this.questionindex + 1]['chapter'];
        }

        // Check if object exists.
        if ((this.questionindex + 1) !== this.quizez.length) {

          // Conditionals.
          if (this.quizez[this.questionindex + 1].conditional) {

            // Get question id.
            var id = this.quizez[this.questionindex + 1].conditional.id;

            // Get all previous answers.
            var obj = this.data;

            // For each given answers.
            Object.keys(obj).forEach(key => {
              var val = obj[key];

              // Find correspondending id.
              if (id === key) {
                var answer_val = obj[key];
                var answer_conditional = this.quizez[this.questionindex + 1].conditional.answers;
                Object.keys(answer_conditional).forEach(answers_key => {

                  // Find same key as answer.
                  if (answer_val === answers_key) {

                    // Put anwsers in the question.
                    var answer_new_val = answer_conditional[answers_key]
                    this.quizez[this.questionindex + 1].answers = answer_new_val;
                  }

                })
              }
            })
          }
        }
        this.stepFadeOut = true;
        this.nextStepActive = true;
        setTimeout(() => this.questionindex++, 0);
        this.opinions = [];

        // Reset values.
        setTimeout(() => this.nextStepActive = false, 1000);
        setTimeout(() => this.stepFadeIn = true, 0);
        setTimeout(() => this.stepFadeOut = false, 0);

        if ((this.questionindex + 1) === this.quizez.length) {
          this.quizDone();
        }
      },
      previousStep: function (switchScreen) {
        this.switchScreenReset();

        this.chapterCurrent = this.quizez[this.questionindex - 1]['chapter'];

        this.stepFadeOut = true;
        this.nextStepActive = true;
        setTimeout(() => this.questionindex--, 0);
        this.opinions = [];

        // Reset values.
        setTimeout(() => this.nextStepActive = false, 1000);
        setTimeout(() => this.stepFadeIn = true, 0);
        setTimeout(() => this.stepFadeOut = false, 0);

      },
      quizDone: function () {
        this.finishUp();
        this.step = 'done';
        this.questionchapter = '';
        console.log(this.grade);
      },
      switchScreenReset: function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      noJob: function () {
        this.unemployed = true;
        this.nextStep();
      },
      mouseOver: function (key, opinion) {
        this.hoverActive = true;
        this.hideChecked = true;
        this.opinions = [];
        this.$set(this.opinions, key, opinion);
      },
      mouseLeave: function () {
        this.hoverActive = false;
        this.hideChecked = false;
        this.opinions = [];
      },
      mouseClick: function (key, checked) {
        this.checked = [];
        this.$set(this.checked, key, checked);
      },
      personalCreate: function () {
        for (let i = 0; i < this.settingsRight.length; i++) {
          if (this.settingsRight[i]['component'] === 'input' && this.settingsRight[i]['type'] !== 'submit') {
            this.personalFill[this.settingsRight[i]['name']] = null;
          }
        }

      },
      submitData: function () {
        this.personalCreate();
        var data = Object.assign({}, this.data);
        var personal = Object.assign({}, this.personalFill);
        var answers = Object.assign({}, this.answers);
        users.doc(this.uid).set({
          personal,
          data,
          answers,
        })
          .then(function () {
            console.log("User document written");
          })
          .catch(function (error) {
            console.error("Error adding user document: ", error);
          });
      },
      submitGrade: function () {
        users.doc(this.uid).update({
          grade: this.grade,
        })
          .then(function () {
            console.log("User document updated");
          })
          .catch(function (error) {
            console.error("Error updating user document: ", error);
          });
      },
      finishUp: function () {
        this.submitData();
        window.onbeforeunload = null;
        if (this.$route.query.grade == undefined) {
          this.getGrade();
        }
        setTimeout(() => this.submitGrade(), 2000);
      },
      submitCredentials: function () {
        users.doc(this.uid).update({
          personal: Object.assign({}, this.personal)
        })
          .then(function () {
            console.log("User document updated");
          })
          .catch(function (error) {
            console.error("Error updating user document: ", error);
          });
        this.success = true;
        var element = document.getElementsByClassName("right");
        var top = element[0].scrollTop;
        element[0].scrollTop = 0;
      },
      checkFormValidate: function () {
        if (this.personal.email) {
          if (!this.validEmail(this.personal.email)) {
            this.errorActive = true;
          }
          if (!this.errorActive) {
            this.submitCredentials();
            return true;
          }
        }
      },
      removeError: function () {
        this.errorActive = false;
      },
      chapterCount: function () {
        var obj = this.quizez;
        var max = 0;
        Object.keys(obj).forEach(key => {
          var val = obj[key]['chapter'];
          if(val > max) {
            max = val;
          }
        })
        this.chapterTotal = max;
      },
      validEmail: function (email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      alertOnLeave: function () {
        window.onbeforeunload = function (e) {
          e.preventDefault();
          return 'Weet je zeker dat je de test af wilt sluiten?';
        };
      },
    },
    mounted() {

      // Get Json data.
      fetch(projects[0]['test']['questions'] + '?v=' + Date.now()).then(r => r.json()).then(json => {
        this.quizez = json;
        this.chapterCurrent = this.quizez[this.questionindex]['chapter'];
        this.questionstotal = this.quizez.length;
        this.chapterCount();
      });

      fetch(projects[0]['test']['settings'] + '?v=' + Date.now()).then(r => r.json()).then(json => {
        this.settings = json[0]['quiz'][0];
        this.settingsLeftTop = json[0]['quiz'][0]['doneLeftTop'];
        this.settingsLeftBottom = json[0]['quiz'][0]['doneLeftBottom'];
        this.settingsRight = json[0]['quiz'][0]['doneRight'];
        this.settingsRightSuccess = json[0]['quiz'][0]['doneRightSuccess'];
      });

      // Get variables.
      this.collection = projects[0]['test']['collection'];
      users = database.collection(this.collection);

      this.debug();
      let querySet = false;
      if (this.$route.query.fill !== undefined || this.$route.query.step !== undefined || this.$route.query.grade !== undefined) {
        querySet = true;
      }
      if (querySet === false && location.hostname !== "localhost") {
        this.alertOnLeave();
      }

      this.toggleBodyClass('addClass', 'quiz');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'quiz');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Quiz.vue